// ============================================================================
// SupportTicketCard.tsx — карточка ОБРАЩЕНИЯ в очереди инбокса поддержки:
// тема, автор, статус/приоритет, канал-источник, время последнего сообщения
// и счётчик. Действия живут в карточке обращения (SupportTicketDetails) —
// здесь только выбор строки очереди.
// ============================================================================

import type { SupportTicket } from '@zdc/sdk';
import { formatValue } from '@/lib/format';
import {
  supportPriorityClass,
  supportPriorityLabel,
  supportStatusClass,
  supportStatusLabel,
} from '@/lib/supportInbox';
import { SupportChannelBadge } from './SupportChannelBadge';

interface Props {
  ticket: SupportTicket;
  selected: boolean;
  onSelect: () => void;
}

function moment(value: string): string {
  if (!value) return '';
  return formatValue(value, '', 'timestamp');
}

export function SupportTicketCard({ ticket, selected, onSelect }: Props) {
  const t = ticket;
  return (
    <button
      type="button"
      onClick={onSelect}
      className={`w-full space-y-1.5 rounded-lg border px-3 py-2 text-left transition-colors ${
        selected ? 'border-primary/50 bg-primary/5' : 'hover:bg-accent/40'
      }`}
    >
      <div className="flex items-start justify-between gap-2">
        <span className="min-w-0 flex-1 truncate text-sm font-medium">
          {t.subject || '(без темы)'}
        </span>
        <span className={`shrink-0 rounded-full border px-2 py-0.5 text-[11px] ${supportStatusClass(t.status)}`}>
          {supportStatusLabel(t.status)}
        </span>
      </div>
      <div className="flex flex-wrap items-center gap-2 text-[11px] text-muted-foreground">
        <span className="truncate">{t.requesterName || 'Автор неизвестен'}</span>
        <span className={`rounded-full border px-2 py-0.5 ${supportPriorityClass(t.priority)}`}>
          {supportPriorityLabel(t.priority)}
        </span>
        <SupportChannelBadge channel={t.channel} />
      </div>
      <div className="flex flex-wrap items-center gap-2 text-[11px] text-muted-foreground">
        <span>{moment(t.lastMessageAt || t.createdAt)}</span>
        <span>сообщений: {t.messageCount}</span>
        {t.assignedName && <span>исполнитель: {t.assignedName}</span>}
        {!t.assignedTo && <span>не назначено</span>}
      </div>
    </button>
  );
}
